import siteConfig from '../../site.config.json'

export default {
  ...siteConfig,
  ga: { trackingID: 'G-8Q6SN0CZ6Y' }
}
